import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  AFFILIATION: {
    OPEN: 'affiliation.open',
    REQUEST_LINK_SHARING: 'affiliation.REQUEST_LINK_SHARING',
    LIST_ALL: {
      REFRESH: 'AFFILIATION.LIST_ALL.REFRESH',
      REFRESHING: 'AFFILIATION.LIST_ALL.REFRESHING',
      REFRESHED: 'AFFILIATION.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'AFFILIATION.LIST_ALL.REFRESH_ERROR'
    }
  }
};

export const ENDPOINTS = {
  AFFILIATION: {
    GET_LIST:
      '/sumremit-transactions/list?userId={userId}&limit=300&group=ecoxurf',
    GET_LIST:
      '/sumremit-transactions/list?userId=&service=ecoxurf&limit=300&group=ecoxurf'
  }
};

export const AFFILIATION = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  },
  SHARINGS: [
    {
      type: 'whatsapp',
      logo: '/images/icons/whatsapp-green.svg',
      name: 'Whatsapp',
      class: 'bg-[#F0F0F0]'
    },
    {
      type: 'facebook',
      logo: '/images/icons/facebook-blue.svg',
      name: 'Facebook',
      class: 'bg-[#F0F0F0]'
    },
    {
      type: 'telegram',
      logo: '/images/icons/telegram-blue.svg',
      name: 'Télégram',
      class: 'bg-[#F0F0F0]'
    },
    {
      type: 'email',
      logo: '/images/icons/gmail.png',
      name: 'Gmail',
      class: 'bg-[#F0F0F0]'
    }
  ]
};
